'use strict';

exports.__esModule = true;
exports['default'] = initialState;

var _validators = require('../../utils/validators');

function initialState(state) {
  return function (target) {
    (0, _validators.validateClass)(target, 'initialState');

    // eslint-disable-next-line
    target.prototype.state = state;
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/react-decoration/lib/decorators/components/initialState.js
// module id = 551
// module chunks = 1